import { Dayjs } from "dayjs";
import { useMemo } from "react";
import { ScaleWeightSeriesData } from "./ScaleWeightsChart.utils";

const sliceSeries = (
  seriesData: ScaleWeightSeriesData,
  startMs: number,
  endMs: number
): ScaleWeightSeriesData => {
  const points = seriesData.x
    .map((date, index) => ({ date, value: seriesData.y[index] }))
    .filter(
      (point): point is { date: Date; value: number } =>
        point.value !== undefined &&
        point.date.getTime() >= startMs &&
        point.date.getTime() <= endMs
    );
  return {
    x: points.map(({ date }) => date),
    y: points.map(({ value }) => value),
  };
};

export const useWindowedSeries = ({
  seriesData,
  visibleStart,
  visibleEnd,
}: {
  seriesData: ScaleWeightSeriesData | undefined;
  visibleStart: Dayjs;
  visibleEnd: Dayjs;
}): ScaleWeightSeriesData | undefined => {
  const visibleStartMs = visibleStart.valueOf();
  const windowMs = visibleEnd.valueOf() - visibleStartMs;
  const bucket = windowMs > 0 ? Math.floor(visibleStartMs / windowMs) : 0;

  return useMemo(() => {
    if (!seriesData || windowMs <= 0) return seriesData;
    const bucketStartMs = bucket * windowMs;
    return sliceSeries(
      seriesData,
      bucketStartMs - windowMs,
      bucketStartMs + 3 * windowMs
    );
  }, [seriesData, bucket, windowMs]);
};
